import React, { useState, useEffect } from "react";
import "../styles/Activities.css";
import CardsActu from "../components/CardsActu";
import chatChute from "../assets/pictures/chatChute.png";
import { useSelector } from "react-redux";

function ActivitiesEdit() {
  const [dataActivity, setDataActivity] = useState([]);
  const role = useSelector((state) => state.role);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const fetchData = async () => {
      try {
        const [eventsResponse, actualitiesResponse] = await Promise.all([
          fetch(`${apiUrl}/api/events/`),
          fetch(`${apiUrl}/api/actualities/`),
        ]);

        if (!eventsResponse.ok || !actualitiesResponse.ok) {
          throw new Error("Erreur lors de la récupération des données");
        }

        const events = await eventsResponse.json();
        const actualities = await actualitiesResponse.json();

        const allActivities = [
          ...events.filter((el) => el.type === "event"),
          ...actualities.filter((el) => el.type === "actuality"),
        ];

        setDataActivity(allActivities);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {role === "admin" && (
        <section className="activities">
          <CardsActu dataActivity={dataActivity} adminToken="adminToken" />
          <img className="chatChute" src={chatChute} alt="chat qui chute" />
        </section>
      )}
    </div>
  );
}

export default ActivitiesEdit;
